module.exports = __webpack_public_path__ + "img/1503393951.47a19f44.jpg";